import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfigService } from 'src/app/core/services/api-config/api-config.service';
import { AppInfo } from 'src/app/shared/types/settings.type';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(
    private http: HttpClient,
    private ApiConfigService: ApiConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.ApiConfigService.apiUrl}`;
  }

  getAppInfo(): Observable<AppInfo> {
    return this.http.get<AppInfo>(`${this.baseUrl}/appinfo`);
  }
}
